webpackJsonp([124826425592542],{

/***/ 608:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"educacion/1/18","node":{"sheet":"Educación","idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"18","card":"¿Quién puede recoger los niños en la escuela?","text":"<p>Los pueden recoger:</p><li>La <b>madre</b></li><li>El <b>padre</b></li><li>Un <b>guardián</b> legal</li><li>Una persona que tiene <b>autorización escrita</b> de la madre o el padre que tiene la custodia física del niño.</li><li>La <b>policía</b> o trabajadores de <b>bienestar infantil</b> que tengan la debida <b>autorización</b>.</li>","url":"https://www.univision.com/noticias/educacion/quien-puede-recoger-los-ninos-en-la-escuela","disclaimer":"<p><i>*Antes de tomar cualquier decisión, consulta con tus autoridades escolares locales.*</i><br></p>"}}}

/***/ })

});


// WEBPACK FOOTER //
// path---educacion-1-18-9514281134a4fdf03451.js